"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.A11yWrapper = exports.isKeyboardEvent = void 0;
var preact_1 = require("preact");
var kaltura_player_js_1 = require("@playkit-js/kaltura-player-js");
var _a = kaltura_player_js_1.ui.utils.KeyMap, ENTER = _a.ENTER, SPACE = _a.SPACE, UP = _a.UP, DOWN = _a.DOWN, LEFT = _a.LEFT, RIGHT = _a.RIGHT;
var stopEvent = function (e) {
    e.preventDefault();
    e.stopPropagation();
};
var isKeyboardEvent = function (e) {
    if (e instanceof KeyboardEvent) {
        return true;
    }
    // Space/Enter keyEvent is swallowed by NVDA (https://github.com/nvaccess/nvda/issues/7898)
    // check additional PointerEvent props to determine if it was triggered by keyboard
    if (e instanceof PointerEvent) {
        // Chrome has offsetX/offsetY as 0, FF doesn't have pointerType
        return [e.offsetX, e.offsetY].every(function (offset) { return offset === 0; }) || !e.pointerType;
    }
    return false;
};
exports.isKeyboardEvent = isKeyboardEvent;
var A11yWrapper = function (_a) {
    var children = _a.children, onClick = _a.onClick, onUpKeyPressed = _a.onUpKeyPressed, onDownKeyPressed = _a.onDownKeyPressed, onLeftKeyPressed = _a.onLeftKeyPressed, onRightKeyPressed = _a.onRightKeyPressed, role = _a.role, type = _a.type;
    var props = {
        onKeyDown: function (e) {
            if (e.keyCode === SPACE || e.keyCode === ENTER) {
                stopEvent(e);
                onClick(e, true);
            }
            else if (e.keyCode === UP && onUpKeyPressed) {
                stopEvent(e);
                onUpKeyPressed(e);
            }
            else if (e.keyCode === DOWN && onDownKeyPressed) {
                stopEvent(e);
                onDownKeyPressed(e);
            }
            else if (e.keyCode === LEFT && onLeftKeyPressed) {
                stopEvent(e);
                onLeftKeyPressed(e);
            }
            else if (e.keyCode === RIGHT && onRightKeyPressed) {
                stopEvent(e);
                onRightKeyPressed(e);
            }
        },
        onClick: function (e) {
            onClick(e, (0, exports.isKeyboardEvent)(e));
        }
    };
    if ((children === null || children === void 0 ? void 0 : children.type) === 'button') {
        props.type = type || 'button';
    }
    if (role !== null) {
        props.role = role;
    }
    return (0, preact_1.cloneElement)(children, props);
};
exports.A11yWrapper = A11yWrapper;
exports.A11yWrapper.defaultProps = {
    role: 'button'
};
//# sourceMappingURL=index.js.map